export const overlay = {
    mt: 1,
    position: "fixed",
    top: 0,
    left: 0,
    height: "100vh",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.45)",
    zIndex: 1500
}

export const formInner = {
    width: 540,
    maxHeight: "90vh",
    overflowY: "auto",
    backgroundColor: "#232323",
    p: 3,
    pt: 0,
    borderRadius: 2,

    "&::-webkit-scrollbar": {
        width: "6px",
    },
    "&::-webkit-scrollbar-track": {
        background: "gray",
    },
    "&::-webkit-scrollbar-thumb": {
        backgroundColor: "lightgray",
        borderRadius: "3px",
    },
}

export const form = {
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
    mt: "20px",

    '& .MuiFormHelperText-root.Mui-error': {
        position: "absolute",
        bottom: "-25px",
    }
}

export const closeButtonInner = {
    display: "flex",
    justifyContent: "end"
}


export const closeButton = {
    width: "25px",
    p: 0,
    minWidth: "20px",
    mt: 1
}

export const dateLabel = {
    m: 0,
    p: 0,
    fontSize: '0.75rem',
    color: 'text.secondary',
}
